import React from "react";
import { IconProps } from "./types";

function IconEmail(props: IconProps) {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="email-gray 300 1" clipPath="url(#clip0_1094_45190)">
        <path
          id="Vector"
          d="M12.6667 3.16669H3.33333C2.8029 3.16669 2.29419 3.3774 1.91912 3.75247C1.54405 4.12755 1.33333 4.63625 1.33333 5.16669V11.8334C1.33333 12.3638 1.54405 12.8725 1.91912 13.2476C2.29419 13.6226 2.8029 13.8334 3.33333 13.8334H12.6667C13.1971 13.8334 13.7058 13.6226 14.0809 13.2476C14.456 12.8725 14.6667 12.3638 14.6667 11.8334V5.16669C14.6667 4.63625 14.456 4.12755 14.0809 3.75247C13.7058 3.3774 13.1971 3.16669 12.6667 3.16669ZM12.22 4.50002L8 7.66669L3.78 4.50002H12.22ZM12.6667 12.5H3.33333C3.15652 12.5 2.98695 12.4298 2.86193 12.3048C2.7369 12.1797 2.66667 12.0102 2.66667 11.8334V5.33335L7.6 9.03335C7.7154 9.1199 7.85575 9.16669 8 9.16669C8.14425 9.16669 8.2846 9.1199 8.4 9.03335L13.3333 5.33335V11.8334C13.3333 12.0102 13.2631 12.1797 13.1381 12.3048C13.013 12.4298 12.8435 12.5 12.6667 12.5Z"
          fill="#1E293B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1094_45190">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default IconEmail;
